/* eslint-disable no-unused-vars */
export const titleToImageMap = {
  // Electronics
  "Wireless Noise-Canceling Headphones":
    "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&auto=format&fit=crop&q=80",
  "Smart Fitness Watch":
    "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&auto=format&fit=crop&q=80",
  "Portable Bluetooth Speaker":
    "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=600&auto=format&fit=crop&q=80",

  // Men
  "Men Premium Jacket":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160852/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1439804198-612x612_upwx0z.jpg",
  "Men Premium Jacket.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160852/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1439804198-612x612_upwx0z.jpg",
  "Men Premium Trending T-Shirts":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160993/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1251683479-612x612_fl1ar5.jpg",
  "Men Premium Trending t-sharts.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160993/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1251683479-612x612_fl1ar5.jpg",
  "Men Premium Trending Long Sleeve T-Shirt":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231181/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1327456615-612x612_n99hjx.jpg",
  "Men Premium Trending sleeves t-shart.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231181/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1327456615-612x612_n99hjx.jpg",
  "Men Premium Trending Jeans & T-Shirt":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231299/E-comm%20ATTIREX/Mens-Fashion/pexels-photo-5753204_nei74i.webp",
  "Men Premium Trending jens t-shart.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231299/E-comm%20ATTIREX/Mens-Fashion/pexels-photo-5753204_nei74i.webp",
  "Men Trending Safari Suit":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684230866/E-comm%20ATTIREX/Mens-Fashion/istockphoto-658846934-612x612_fkwpu2.jpg",
  "Men Trending Safari.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684230866/E-comm%20ATTIREX/Mens-Fashion/istockphoto-658846934-612x612_fkwpu2.jpg",
  "Men Trending Safari Pants":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231008/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1345963025-612x612_ostie7.jpg",
  "Men Trending Safari pant.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231008/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1345963025-612x612_ostie7.jpg",

  // Women
  "Women Premium Jacket":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160313/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1421800979-612x612_jhezda.jpg",
  "Premium Jacket.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160521/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1142195614-612x612_qgxaym.jpg",
  "Women Premium Saree":
    "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&auto=format&fit=crop&q=80",
  "Women Premium Saree.":
    "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&auto=format&fit=crop&q=80",
  "Women Premium Dress":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232697/E-comm%20ATTIREX/Womens-Fashion/pexels-photo-11772316_qj6ma3.webp",
  "Women Premium Dress.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232697/E-comm%20ATTIREX/Womens-Fashion/pexels-photo-11772316_qj6ma3.webp",
  "Women Designer Floral Dress":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232576/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1210757774-612x612_afynjb.jpg",
  "Women Classic Casual Wear":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160594/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1097372032-612x612_al3xnl.jpg",
  "Women.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684161112/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1353609468-612x612_yiv7ax.jpg",
  "Women Party Dress":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684161231/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1417865925-612x612_hkynsy.jpg",
  "Women party dress.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684233244/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1202807525-612x612_oknke7.jpg",
  "Girls Premium Frock":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160787/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1361311726-612x612_cnjg6c.jpg",
  "Girls frokes.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160787/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1361311726-612x612_cnjg6c.jpg",

  // Kids
  "Kids Premium Jacket":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684621708/E-comm%20ATTIREX/Kids-Fashion/hmgoepprod_zvhtpt.webp",
  "Kids Premium Jacket.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684621708/E-comm%20ATTIREX/Kids-Fashion/hmgoepprod_zvhtpt.webp",
  "Kids Premium Coat":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160742/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1296361252-612x612_rkq0ow.jpg",
  "Kids Premium coat.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160742/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1296361252-612x612_rkq0ow.jpg",
  "Kids Premium Coat & Pants":
    "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=600&auto=format&fit=crop&q=80",
  "Kids Premium coat+pant.":
    "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=600&auto=format&fit=crop&q=80",
  "Kids Premium T-Shirt":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160795/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1356594834-612x612_p1ywwg.jpg",
  "Kids t-shart.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160795/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1356594834-612x612_p1ywwg.jpg",
  "Baby Denim Jeans Outfit":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160742/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1296361252-612x612_rkq0ow.jpg",
  "Jens little baby":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160742/E-comm%20ATTIREX/Kids-Fashion/istockphoto-1296361252-612x612_rkq0ow.jpg",

  // Home & Activewear
  "Home Premium Clothes":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684156820/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1366038769-612x612_pa4c9e.jpg",
  "Home Premium Cloths.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684156820/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1366038769-612x612_pa4c9e.jpg",
  "Home Premium T-Shirt":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231969/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1216112341-612x612_g0fann.jpg",
  "Home primium t-shart":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231969/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1216112341-612x612_g0fann.jpg",
  "Home Premium Joggers":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232026/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1307931676-612x612_xvnuse.jpg",
  "Home primium lower":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232026/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1307931676-612x612_xvnuse.jpg",
  "Home Premium Jeans":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160987/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1220376914-612x612_qonriu.jpg",
  "Home primium Jens":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160987/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1220376914-612x612_qonriu.jpg",

  // Wedding & Travel
  "Wedding Premium Clothes":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684230938/E-comm%20ATTIREX/Mens-Fashion/istockphoto-155394131-612x612_lqdnjg.jpg",
  "Weeding Premium Cloths.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684230938/E-comm%20ATTIREX/Mens-Fashion/istockphoto-155394131-612x612_lqdnjg.jpg",
  "Men Royal Wedding Sherwani":
    "https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&auto=format&fit=crop&q=80",
  "Travelling Premium Clothes":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231488/E-comm%20ATTIREX/Mens-Fashion/pexels-photo-1129019_s4qgfw.webp",
  "Travelling Premium Cloths.":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684231488/E-comm%20ATTIREX/Mens-Fashion/pexels-photo-1129019_s4qgfw.webp",
  "Wedding Bridal Gown":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684233369/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1143043139-612x612_qi32jp.jpg",
  "Weeding dress":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684233369/E-comm%20ATTIREX/Womens-Fashion/istockphoto-1143043139-612x612_qi32jp.jpg",
  "Wedding Party Dress":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232933/E-comm%20ATTIREX/Womens-Fashion/istockphoto-186829751-612x612_oa04tb.jpg",
  "Weeding party dress":
    "https://res.cloudinary.com/dptfwcnro/image/upload/v1684232933/E-comm%20ATTIREX/Womens-Fashion/istockphoto-186829751-612x612_oa04tb.jpg",
  "Wedding Ceremony Saree":
    "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=600&auto=format&fit=crop&q=80",
  "Weeding Ceremoney saree":
    "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=600&auto=format&fit=crop&q=80",
};

export const COLLECTION_TILES = [
  {
    title: "Active Wear",
    subCategory: "Active Wear",
    image: titleToImageMap["Home Premium Clothes"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911285/E-comm%20ATTIREX/ActiveWear_j3uzrc.jpg",
    featuredProductTitle: "Home Premium Clothes",
  },
  {
    title: "Dresses",
    subCategory: "Dresses",
    image: titleToImageMap["Women Premium Dress"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911465/E-comm%20ATTIREX/WesternDress_xzucw4.jpg",
    featuredProductTitle: "Women Premium Dress",
  },
  {
    title: "Office Wear",
    subCategory: "Office Wear",
    image: titleToImageMap["Women Premium Jacket"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911560/E-comm%20ATTIREX/Office-Wear_o9xrse.jpg",
    featuredProductTitle: "Women Premium Jacket",
  },
  {
    title: "Freestyle",
    subCategory: "Freestyle",
    image: titleToImageMap["Men Premium Trending Jeans & T-Shirt"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911604/E-comm%20ATTIREX/Freestyle_suh2kw.jpg",
    featuredProductTitle: "Men Premium Trending Jeans & T-Shirt",
  },
  {
    title: "Men's Formal",
    subCategory: "Men's Formal",
    image: titleToImageMap["Men Trending Safari Suit"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911646/E-comm%20ATTIREX/Formal_hmsktj.jpg",
    featuredProductTitle: "Men Trending Safari Suit",
  },
  {
    title: "Sarees & Ethnic",
    subCategory: "Sarees & Ethnic",
    image: titleToImageMap["Women Premium Saree"],
    fallback:
      "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&auto=format&fit=crop&q=80",
    featuredProductTitle: "Women Premium Saree",
  },
  {
    title: "Casual",
    subCategory: "Casual",
    image: titleToImageMap["Men Premium Trending T-Shirts"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911766/E-comm%20ATTIREX/CasualMen_hekinb.jpg",
    featuredProductTitle: "Men Premium Trending T-Shirts",
  },
  {
    title: "Tops",
    subCategory: "Tops",
    image: titleToImageMap["Women Classic Casual Wear"],
    fallback:
      "https://res.cloudinary.com/dptfwcnro/image/upload/v1683911811/E-comm%20ATTIREX/Tops_fiapqb.jpg",
    featuredProductTitle: "Women Classic Casual Wear",
  },
];

export const SUB_CATEGORY_OPTIONS = [
  "Active Wear",
  "Dresses",
  "Tops",
  "Office Wear",
  "Casual",
  "Freestyle",
  "Men's Formal",
  "Sarees & Ethnic",
];

export const matchesSubCategory = (product, subCat) => {
  if (!product || !subCat) return false;
  const t = (product.title || "").toLowerCase();
  const c = (product.category?.name || "").toLowerCase();

  switch (subCat) {
    case "Active Wear":
      return (
        t.includes("jogger") ||
        t.includes("lower") ||
        t.includes("home premium clothes") ||
        t.includes("home premium cloths") ||
        t.includes("home premium t-shirt") ||
        t.includes("home primium") ||
        t.includes("fitness")
      );
    case "Dresses":
      return (
        t.includes("dress") ||
        t.includes("gown") ||
        t.includes("frock") ||
        t.includes("froke")
      );
    case "Tops":
      return (
        t.includes("women classic casual") ||
        t === "women." ||
        t.includes("women premium jacket") ||
        t === "premium jacket." ||
        t.includes("t-shirt") ||
        t.includes("t-shart")
      );
    case "Office Wear":
      return (
        t.includes("women premium jacket") ||
        t === "premium jacket." ||
        t.includes("safari") ||
        t.includes("coat")
      );
    case "Casual":
      return (
        t.includes("trending t-shirt") ||
        t.includes("trending t-shart") ||
        t.includes("jacket") ||
        t.includes("jeans") ||
        t.includes("jens") ||
        t.includes("casual")
      );
    case "Freestyle":
      return (
        t.includes("jeans & t-shirt") ||
        t.includes("jens t-shart") ||
        t.includes("trending t-shirt") ||
        t.includes("trending t-shart") ||
        t.includes("sleeve") ||
        t.includes("travelling")
      );
    case "Men's Formal":
      return (
        t.includes("safari") ||
        t.includes("wedding premium") ||
        t.includes("weeding premium") ||
        t.includes("sherwani") ||
        t.includes("coat")
      );
    case "Sarees & Ethnic":
      return (
        t.includes("saree") ||
        t.includes("wedding") ||
        t.includes("weeding") ||
        t.includes("bridal")
      );
    default:
      return t.includes(subCat.toLowerCase()) || c.includes(subCat.toLowerCase());
  }
};

const defaultImage =
  "https://res.cloudinary.com/dptfwcnro/image/upload/v1684160993/E-comm%20ATTIREX/Mens-Fashion/istockphoto-1251683479-612x612_fl1ar5.jpg";

export const getFallbackImage = (seed = "") => {
  const trimmed = (seed || "").trim();
  if (titleToImageMap[trimmed]) {
    return titleToImageMap[trimmed];
  }

  const lSeed = trimmed.toLowerCase();
  for (const [key, url] of Object.entries(titleToImageMap)) {
    if (key.toLowerCase() === lSeed) {
      return url;
    }
  }

  if (
    lSeed.includes("headphone") ||
    lSeed.includes("earphone") ||
    lSeed.includes("audio")
  )
    return titleToImageMap["Wireless Noise-Canceling Headphones"];
  if (
    lSeed.includes("watch") ||
    lSeed.includes("smartwatch") ||
    lSeed.includes("fitness")
  )
    return titleToImageMap["Smart Fitness Watch"];
  if (
    lSeed.includes("speaker") ||
    lSeed.includes("sound") ||
    lSeed.includes("bluetooth")
  )
    return titleToImageMap["Portable Bluetooth Speaker"];
  if (lSeed.includes("electronic"))
    return titleToImageMap["Wireless Noise-Canceling Headphones"];

  if (
    lSeed.includes("kid") ||
    lSeed.includes("baby") ||
    lSeed.includes("girl") ||
    lSeed.includes("frock")
  )
    return titleToImageMap["Kids Premium Jacket"];
  if (lSeed.includes("saree")) return titleToImageMap["Women Premium Saree"];
  if (lSeed.includes("dress")) return titleToImageMap["Women Premium Dress"];
  if (lSeed.includes("jacket") || lSeed.includes("coat"))
    return titleToImageMap["Men Premium Jacket"];
  if (
    lSeed.includes("pant") ||
    lSeed.includes("jeans") ||
    lSeed.includes("lower") ||
    lSeed.includes("jogger")
  )
    return titleToImageMap["Home Premium Jeans"];
  if (lSeed.includes("home")) return titleToImageMap["Home Premium Clothes"];
  if (
    lSeed.includes("t-shirt") ||
    lSeed.includes("tshirt") ||
    lSeed.includes("shirt")
  )
    return titleToImageMap["Men Premium Trending T-Shirts"];
  if (lSeed.includes("wedding")) return titleToImageMap["Wedding Bridal Gown"];
  if (lSeed.includes("travel"))
    return titleToImageMap["Travelling Premium Clothes"];
  if (lSeed.includes("women")) return titleToImageMap["Women Premium Dress"];
  if (lSeed.includes("men"))
    return titleToImageMap["Men Premium Trending T-Shirts"];

  return defaultImage;
};

export const getProductImage = (product) => {
  if (!product) return defaultImage;
  const trimmedTitle = (product.title || "").trim();
  if (titleToImageMap[trimmedTitle]) {
    return titleToImageMap[trimmedTitle];
  }
  const img = product.images && product.images[0];
  if (img && typeof img === "string" && !img.includes("pollinations.ai")) {
    return img;
  }
  return getFallbackImage(product.title);
};

const TYPO_TITLE_MAP = {
  "Men Premium Jacket.": "Men Premium Jacket",
  "Men Premium Trending t-sharts.": "Men Premium Trending T-Shirts",
  "Men Premium Trending sleeves t-shart.": "Men Premium Trending Long Sleeve T-Shirt",
  "Men Premium Trending jens t-shart.": "Men Premium Trending Jeans & T-Shirt",
  "Men Trending Safari.": "Men Trending Safari Suit",
  "Men Trending Safari pant.": "Men Trending Safari Pants",
  "Premium Jacket.": "Women Premium Jacket",
  "Women Premium Saree.": "Women Premium Saree",
  "Women Premium Dress.": "Women Premium Dress",
  "Women.": "Women Classic Casual Wear",
  "Women party dress.": "Women Party Dress",
  "Girls frokes.": "Girls Premium Frock",
  "Kids Premium Jacket.": "Kids Premium Jacket",
  "Kids Premium coat.": "Kids Premium Coat",
  "Kids Premium coat+pant.": "Kids Premium Coat & Pants",
  "Kids t-shart.": "Kids Premium T-Shirt",
  "Jens little baby": "Baby Denim Jeans Outfit",
  "Home Premium Cloths.": "Home Premium Clothes",
  "Home primium t-shart": "Home Premium T-Shirt",
  "Home primium lower": "Home Premium Joggers",
  "Home primium Jens": "Home Premium Jeans",
  "Weeding Premium Cloths.": "Wedding Premium Clothes",
  "Travelling Premium Cloths.": "Travelling Premium Clothes",
  "Weeding dress": "Wedding Bridal Gown",
  "Weeding party dress": "Wedding Party Dress",
  "Weeding Ceremoney saree": "Wedding Ceremony Saree",
};

export const formatProductTitle = (title = "") => {
  const trimmed = (title || "").trim();
  if (TYPO_TITLE_MAP[trimmed]) return TYPO_TITLE_MAP[trimmed];
  return trimmed
    .replace(/\bweeding\b/gi, "Wedding")
    .replace(/\bceremoney\b/gi, "Ceremony")
    .replace(/\bprimium\b/gi, "Premium")
    .replace(/\bt-sharts?\b/gi, "T-Shirt")
    .replace(/\bjens\b/gi, "Jeans")
    .replace(/\bcloths\b/gi, "Clothes")
    .replace(/\bfrokes?\b/gi, "Frock")
    .replace(/\.+$/, "")
    .trim();
};

export const normalizeProduct = (product) => {
  if (!product) return product;
  const cleanTitle = formatProductTitle(product.title);
  const cleanDesc = (product.description || "")
    .replace(/\bweeding\b/gi, "wedding")
    .replace(/\bceremoney\b/gi, "ceremony")
    .replace(/\bprimium\b/gi, "premium")
    .replace(/\bt-sharts?\b/gi, "t-shirt")
    .replace(/\bjens\b/gi, "jeans")
    .replace(/\bcloths\b/gi, "clothes")
    .replace(/\bfrokes?\b/gi, "frock");
  return {
    ...product,
    title: cleanTitle || product.title,
    description: cleanDesc || product.description,
  };
};

export const normalizeProductList = (products = []) => {
  const seen = new Set();
  const result = [];
  for (const raw of products) {
    if (!raw) continue;
    const item = normalizeProduct(raw);
    const key = `${(item.title || "").toLowerCase()}|${getProductImage(item)}`;
    const titleKey = (item.title || "").toLowerCase();
    if (!seen.has(key) && !seen.has(titleKey)) {
      seen.add(key);
      seen.add(titleKey);
      result.push(item);
    }
  }
  return result;
};
